import { gql } from '@apollo/client';

export interface RoutePlanningTaskQueryInput {
    taskId: number;
    parcelNumberStart: number;
    parcelNumberEnd: number;
}

export interface RoutePlanningOrderResult {
    orderId: number;
    stopNumber: number;
}

export interface RoutePlanningSegmentResult {
    driverAccountId: number;
    orders: RoutePlanningOrderResult[];
    parcelNumberStart: number;
    parcelNumberEnd: number;
}

export interface RoutePlanningTaskResult {
    status: 'PLANNING' | 'COMPLETED' | 'FAILED';
    segments: RoutePlanningSegmentResult[];
}

export interface GetRoutePlanningTaskResultResponse {
    getRoutePlanningTaskResult: RoutePlanningTaskResult;
}

export interface GetRoutePlanningTaskResultVariables {
    queries: RoutePlanningTaskQueryInput[];
}

export const GET_ROUTE_PLANNING_TASK_RESULT = gql`
    query GetRoutePlanningTaskResult($queries: [RoutePlanningTaskQueryInput!]!) {
        getRoutePlanningTaskResult(queries: $queries) {
            status
            segments {
                driverAccountId
                orders {
                    orderId
                    stopNumber
                }
                parcelNumberStart
                parcelNumberEnd
            }
        }
    }
`;
